import { Controller } from "@hotwired/stimulus"

// Toggles between the "matched ingredient" panel and the "new ingredient" form.
// Lets a mis-click on "c'est un ingrédient différent" be reverted back to the
// suggested match without losing the detected data.
export default class extends Controller {
  static targets = ["panel", "newForm", "bulkAction", "existingId", "existingPrice"]
  static values = { ingredientId: String }

  reject() {
    if (this.hasBulkActionTarget) this.bulkActionTarget.value = "new"
    if (this.hasExistingIdTarget) this.existingIdTarget.value = ""
    if (this.hasExistingPriceTarget) this.existingPriceTarget.disabled = true
    if (this.hasPanelTarget) this.panelTarget.style.display = "none"
    if (this.hasNewFormTarget) this.newFormTarget.style.display = "block"
  }

  revert() {
    if (this.hasBulkActionTarget) this.bulkActionTarget.value = "existing"
    if (this.hasExistingIdTarget) this.existingIdTarget.value = this.ingredientIdValue
    if (this.hasExistingPriceTarget) this.existingPriceTarget.disabled = false
    if (this.hasPanelTarget) this.panelTarget.style.display = ""
    if (this.hasNewFormTarget) this.newFormTarget.style.display = "none"
  }
}
